import {
  CoachingLibraryCatalogue,
  CoachingSuggestion,
} from '@euler/model/coaching';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';

export interface CoachingHomeData {
  /** Null while loading. */
  suggestions: CoachingSuggestion[] | null;
  catalogue: CoachingLibraryCatalogue | null;
  failed: boolean;
  reload: () => void;
}

/** What the start page shows: suggestions and the library's collections. */
export function useCoachingHome(): CoachingHomeData {
  const { coachingService } = useServiceFactory();
  const [suggestions, setSuggestions] = useState<CoachingSuggestion[] | null>(
    null,
  );
  const [catalogue, setCatalogue] = useState<CoachingLibraryCatalogue | null>(
    null,
  );
  const [failed, setFailed] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey(k => k + 1), []);

  useEffect(() => {
    let active = true;
    setFailed(false);
    Promise.all([
      coachingService.getSuggestions(),
      coachingService.getCatalogue(),
    ])
      .then(([items, library]) => {
        if (!active) return;
        setSuggestions(items);
        setCatalogue(library);
      })
      .catch(error => {
        console.error('coaching home failed', error);
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [coachingService, reloadKey]);

  return { suggestions, catalogue, failed, reload };
}
